import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { getIsBrandPreview, useIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { getRetailer } from "@faire/retailer-visitor-shared/serialized-data/getRetailer";
import { useSettingAndAssignMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { UserStore, useUserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
/**
 * @deprecated Use `useIsLoggedInRetailer` instead
 */ export var isLoggedInRetailer = function() {
    var _getRetailer;
    return !!UserStore.get().userToken && !!getRetailer() && !((_getRetailer = getRetailer()) === null || _getRetailer === void 0 ? void 0 : _getRetailer.is_guest) && !getIsBrandPreview();
};
export var useIsLoggedInRetailer = function() {
    var userToken = useUserStore([
        "userToken"
    ]).userToken;
    var retailerToken = useRetailer().retailerToken;
    var isGuestRetailer = useIsGuestRetailer();
    var isBrandPreview = useIsBrandPreview();
    return !!userToken && !!retailerToken && !isBrandPreview && !isGuestRetailer;
};
export var useIsLoggedInRetailerOrBrandPreview = function() {
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var isBrandPreview = useIsBrandPreview();
    return isLoggedInRetailer || isBrandPreview;
};
/**
 * @deprecated Use `useIsLoggedInRetailerOrBrandPreview` instead
 */ export var isLoggedInRetailerOrBrandPreview = function() {
    return isLoggedInRetailer() || getIsBrandPreview();
};
var useIsGuestRetailer = function() {
    var shouldUseHooksMigration = useSettingAndAssignMigrateRetailerStore();
    var retailer = useRetailer().retailer;
    var _useRetailerStore = useRetailerStore([
        "isGuestRetailer"
    ]), isGuestRetailerControl = _useRetailerStore.isGuestRetailer;
    if (shouldUseHooksMigration) {
        var _retailer_is_guest;
        return (_retailer_is_guest = retailer === null || retailer === void 0 ? void 0 : retailer.is_guest) !== null && _retailer_is_guest !== void 0 ? _retailer_is_guest : false;
    }
    return isGuestRetailerControl !== null && isGuestRetailerControl !== void 0 ? isGuestRetailerControl : false;
};
